import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Payment Type Cell Renderer
 * Muestra método de pago (bold) y tipo de pago
 */
@Component({
  selector: 'app-payment-type-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ methodName }}</span>
      <span class="text-sm text-gray-500 dark:text-gray-400">{{ typeName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class PaymentTypeCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get methodName(): string {
    return this.params?.data?.paymentMethod?.name ?? '-';
  }

  get typeName(): string {
    return this.params?.data?.paymentType?.name ?? '-';
  }
}
